//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from "vuex";
export default {
  name: "SAPS_two",
  data() {
    return {
      form: {
        value1: "",
        value2: "",
        value3: "",
        value4: "",
        value5: "",
        value6: "",
        value7: "",
        value8: "",
        value9: "",
        value10: "",
        value11: "",
        value12: "",
        value13: "",
        value14: "",
      },
      form1:{
        value1:'0',
        value2:'0',
        value3:'0',
      },
      hasScore: false,
      disabled: false,
      dataList: [
        { value: "0", name: "＜40" },
        { value: "7", name: "40-59" },
        { value: "12", name: "60-69" },
        { value: "15", name: "70-74" },
        { value: "16", name: "75-79" },
        { value: "18", name: "≥80" },
      ],
      dataList1: [
        { value: "0", name: "70-119" },
        { value: "2", name: "40-69" },
        { value: "4", name: "120-159" },
        { value: "7", name: "≥160" },
        { value: "11", name: "＜40" },
      ],
      dataList2: [
        { value: "0", name: "100-199" },
        { value: "2", name: "≥200" },
        { value: "5", name: "70-99" },
        { value: "13", name: "＜70" },
      ],
      dataList3: [
        { value: "0", name: "＜39℃" },
        { value: "3", name: "≥39℃" },
      ],
      dataList4: [
        { value: "6", name: "≥200" },
        { value: "9", name: "100-199" },
        { value: "11", name: "＜100" },
      ],
      dataList5: [
        { value: "0", name: "≥1.000" },
        { value: "4", name: "0.500-0.999" },
        { value: "11", name: "＜0.500" },
      ],
      dataList6: [
        { value: "0", name: "＜28" },
        { value: "6", name: "29-83" },
        { value: "10", name: "≥84" },
      ],
      dataList7: [
        { value: "0", name: "1.0-19.9" },
        { value: "3", name: "≥20.0" },
        { value: "12", name: "＜1.0" },
      ],
      dataList8: [
        { value: "0", name: "3.0-4.9" },
        { value: "3.0", name: "＜3.0" },
        { value: "3", name: "≥5.0" },
      ],
      dataList9: [
        { value: "0", name: "125-144" },
        { value: "1", name: "≥145" },
        { value: "5", name: "125" },
      ],
      dataList10: [
        { value: "0", name: "≥20" },
        { value: "3", name: "15-19" },
        { value: "6", name: "＜15" },
      ],
      dataList11: [
        { value: "0", name: "＜68.4（＜4.0）" },
        { value: "4", name: "68.4-102.5（4.0-5.9）" },
        { value: "9", name: "≥102.6（≥6.0）" },
      ],
      dataList12: [
        { value: "0", name: "14-15" },
        { value: "5", name: "11-13" },
        { value: "7", name: "9-10" },
        { value: "13", name: "6-8" },
        { value: "26", name: "＜6" },
      ],
      dataList13: [
        { value: "0", name: "择期手术" },
        { value: "6", name: "内科患者" },
        { value: "8", name: "急诊手术" },
      ],
    };
  },
  created() {
    this.hideLoad();
  },
  methods: {
    ...mapMutations(["hideLoad"]),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this;
      let form = JSON.parse(JSON.stringify(self.form));
      let form1 = JSON.parse(JSON.stringify(self.form1));
      let flag = true;
      let sum = 0;
      let logit = 0
      let result = 0
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false;
          } else {
            form[key] = Number(form[key]);
          }
        }
        sum += Number(form[key]);
      }
      for (const key in form1) {
        if (form1.hasOwnProperty(key)) {
          if (!form1[key]) {
            flag = false;
          } else {
            form1[key] = Number(form1[key]);
          }
        }
      }
      if (!flag) {
        self.hasScore = false;
        return "";
      } else {
        self.hasScore = true;
        sum =sum + (form1.value1 ? 9:0) + (form1.value2 ? 10:0) + (form1.value3 ? 17 :0)
        logit = -7.7631 + 0.0737 * sum + 0.997 * Math.log(sum + 1)
        result = (Math.pow(Math.E,logit) / (1 + Math.pow(Math.E,logit))*100).toFixed(2)
        return String(result);
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/SAPS_two.vue